<template>
  <div
    v-if="data"
    class="basic_wrap play-page"
  >
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit van-ellipsis">
        {{ $t('sky.ying') }}
        <!-- {{ getVideoTitle(data) }} -->
      </div>
    </div>

    <div class="movie-content">
      <section class="player-card">
        <video
          ref="videoPlayer"
          class="video-js vjs-default-skin"
          webkit-playsinline="false"
          role="application"
          tabindex="-1"
          preload="auto"
          playsinline="playsinline"
          controls
          controlslist="nofullscreen"
          autoplay="autoplay"
          width="100%"
        />
      </section>

      <section class="movie-descript">
        <div class="video-name">
          {{ getVideoTitle(data) }}
        </div>
        <span class="play-pill">
          <van-icon name="play-circle-o" />
          {{ data.pnum }} {{ $t('sky.play') }}
        </span>
      </section>

      <div class="watch-benefits">
        <div class="watch-benefits-link">
          <span class="watch-benefits-copy">
            <strong>{{ $t('playDesign.trialAllowance', { seconds: trialLimitSeconds }) }}</strong>
            <span>{{ $t('playDesign.viewVip') }}</span>
          </span>
          <span
            class="watch-benefits-arrow"
            aria-hidden="true"
          >
            <van-icon name="arrow" />
          </span>
        </div>
      </div>

      <section class="movie-body">
        <div class="movie-title">
          <span
            class="section-marker"
            aria-hidden="true"
          />
          <span>{{ $t('sky.retui') }}</span>
        </div>
        <div
          v-if="list"
          class="hotlist"
        >
          <article
            v-for="item in list"
            :key="item.id"
            class="hot-card"
            @click="tovideo(item.id)"
          >
            <div class="hot-cover">
              <img
                :src="formatAssetUrl(item.pic)"
                alt=""
              >
              <div class="hot-meta">
                <span>{{ $t('sky.play') }}: {{ item.pnum }}</span>
              </div>
            </div>
            <div
              class="hot-name"
              :title="getVideoTitle(item)"
            >
              {{ getVideoTitle(item) }}
            </div>
          </article>
        </div>
      </section>
    </div>

    <div
      v-if="showWatchTip"
      class="watch-mask"
    >
      <div class="watch-dialog">
        <div class="watch-title">
          <span>{{ $t('sky.watchVideoTitle') }}</span>
          <button
            type="button"
            class="watch-close"
            aria-label="close"
            @click="closeshowtip"
          >
            <van-icon name="cross" />
          </button>
        </div>
        <div class="watch-content">
          {{ $t('sky.watchVideoTrialTip') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import Fetch from "../../utils/fetch";
import { formatAssetUrl } from "../../utils/assets";

Vue.use(Icon);

export default {
	name: "Vplay",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: null,
			loading: false,
			page: 1,
			list: null,
			player: null,
			adSkipSeconds: 0,
			trialLimitSeconds: 20,
			trialStartTime: 0,
			maxWatchedTime: 0,
			isResettingSeek: false,
			trialStopped: false,
			cur: 0,
			area: null,
			arealist: null,
			locationsel: false,
			type: 0,
			finished: false,
			empty: false,
			showWatchTip: false,
		};
	},
	created() {
		this.$parent.footer("video", true);
	},
	mounted() {
		this.initPlayer();
		this.start();
		this.showWatchTip = true;
	},
	beforeDestroy() {
		if (this.player) {
			this.player.off("loadedmetadata", this.skipOpeningAd);
			this.player.off("timeupdate", this.limitTrialPlay);
			this.player.off("seeking", this.preventSeek);
			this.player.off("play", this.preventTrialReplay);
			this.player.dispose();
			this.player = null;
		}
	},
	beforeRouteUpdate(to, from, next) {
		next();
		this.showWatchTip = true;
		this.video(to.params.code);
	},
	methods: {
		formatAssetUrl,
		getVideoTitle(item) {
			var title = item && item.title !== undefined && item.title !== null ? String(item.title).trim() : "";

			return title || this.$t("sky.ying");
		},
		closeshowtip() {
			this.showWatchTip = false;
			if (this.trialStopped) {
				this.$router.push("/vindex");
			}
		},
		initPlayer() {
			if (this.player || !this.$refs.videoPlayer) {
				return;
			}
			this.player = videojs(this.$refs.videoPlayer, {
				controls: true,
				autoplay: false,
				preload: "auto",
				fluid: true,
			});
			this.player.on("loadedmetadata", this.skipOpeningAd);
			this.player.on("timeupdate", this.limitTrialPlay);
			this.player.on("seeking", this.preventSeek);
			this.player.on("play", this.preventTrialReplay);
		},
		setVideoSource(url) {
			if (!url) {
				return;
			}
			if (!this.player) {
				this.initPlayer();
			}
			var type = /\.m3u8($|\?)/i.test(url) ? "application/x-mpegURL" : "video/mp4";
			this.adSkipSeconds = 0;
			this.trialStartTime = 0;
			this.maxWatchedTime = 0;
			this.trialStopped = false;
			this.isResettingSeek = false;
			this.player.pause();
			this.player.src({
				src: url,
				type: type,
			});
			this.loadAdSkipSeconds(url);
			this.player.load();
			var promise = this.player.play();
			if (promise && promise.catch) {
				promise.catch(() => {});
			}
		},
		loadAdSkipSeconds(url) {
			if (!/\.m3u8($|\?)/i.test(url)) {
				return;
			}
			this.getOpeningAdSeconds(url).then(seconds => {
				this.adSkipSeconds = seconds;
				this.trialStartTime = seconds || 0;
				this.maxWatchedTime = this.trialStartTime;
				this.skipOpeningAd();
			}).catch(() => {
				this.adSkipSeconds = 0;
				this.trialStartTime = 0;
				this.maxWatchedTime = 0;
			});
		},
		skipOpeningAd() {
			if (!this.player || !this.adSkipSeconds || this.player.currentTime() >= this.adSkipSeconds) {
				return;
			}
			this.isResettingSeek = true;
			this.maxWatchedTime = this.adSkipSeconds;
			this.player.currentTime(this.adSkipSeconds);
			setTimeout(() => {
				this.isResettingSeek = false;
			}, 100);
		},
		getTrialEndTime() {
			return this.trialStartTime + this.trialLimitSeconds;
		},
		limitTrialPlay() {
			if (!this.player) {
				return;
			}
			var currentTime = this.player.currentTime();
			var endTime = this.getTrialEndTime();
			if (currentTime > this.maxWatchedTime && currentTime <= endTime) {
				this.maxWatchedTime = currentTime;
			}
			if (currentTime >= endTime) {
				this.trialStopped = true;
				this.isResettingSeek = true;
				this.player.currentTime(endTime);
				this.player.pause();
				this.showWatchTip = true;
				setTimeout(() => {
					this.isResettingSeek = false;
				}, 100);
			}
		},
		preventSeek() {
			if (!this.player || this.isResettingSeek) {
				return;
			}
			var currentTime = this.player.currentTime();
			var endTime = this.getTrialEndTime();
			if (currentTime > this.maxWatchedTime + 0.8 || currentTime < this.trialStartTime - 0.5 || currentTime > endTime) {
				var safeTime = Math.min(Math.max(this.maxWatchedTime, this.trialStartTime), endTime);
				this.isResettingSeek = true;
				this.player.currentTime(safeTime);
				setTimeout(() => {
					this.isResettingSeek = false;
				}, 100);
			}
		},
		preventTrialReplay() {
			if (!this.player || !this.trialStopped) {
				return;
			}
			this.player.pause();
			this.player.currentTime(this.getTrialEndTime());
		},
		getOpeningAdSeconds(url) {
			return fetch(url, {
				cache: "no-cache",
			}).then(response => response.text()).then(text => {
				var mediaUrl = this.getMediaPlaylistUrl(url, text);
				if (!mediaUrl) {
					return text;
				}
				return fetch(mediaUrl, {
					cache: "no-cache",
				}).then(response => response.text());
			}).then(text => {
				return this.parseOpeningAdSeconds(text);
			});
		},
		getMediaPlaylistUrl(baseUrl, text) {
			var lines = text.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
			for (var i = 0; i < lines.length; i++) {
				if (lines[i].indexOf("#EXT-X-STREAM-INF") === 0) {
					for (var j = i + 1; j < lines.length; j++) {
						if (lines[j].indexOf("#") !== 0) {
							return this.toAbsoluteUrl(baseUrl, lines[j]);
						}
					}
				}
			}
			return null;
		},
		parseOpeningAdSeconds(text) {
			var seconds = 0;
			var lines = text.split(/\r?\n/);
			for (var i = 0; i < lines.length; i++) {
				var line = lines[i].trim();
				if (line.indexOf("#EXT-X-DISCONTINUITY") === 0) {
					return seconds > 0 && seconds <= 90 ? seconds : 0;
				}
				if (line.indexOf("#EXTINF:") === 0) {
					var value = parseFloat(line.replace("#EXTINF:", "").split(",")[0]);
					if (!isNaN(value)) {
						seconds += value;
					}
				}
			}
			return 0;
		},
		toAbsoluteUrl(baseUrl, path) {
			if (/^https?:\/\//i.test(path)) {
				return path;
			}
			var url = new URL(baseUrl);
			if (path.indexOf("/") === 0) {
				return url.origin + path;
			}
			return baseUrl.replace(/\/[^/]*$/, "/") + path;
		},
		tovideo(id) {
			this.$router.push("/vplay/" + id);
		},
		video(id) {
			if (this.player) {
				this.player.pause();
			}
			Fetch("/user/video", {
				id: id,
			}).then(res => {
				this.data = res.data.vedio;
				this.list = res.data.list;
				this.$nextTick(() => {
					this.setVideoSource(this.data.url);
				});
			});
		},
		start() {
			this.video(this.$router.history.current.params.code);
		},
	},
};
</script>

<style lang="less" scoped>
.play-page {
  --accent: #f3c99e;
  --text: #eee;
  --muted: #c4c4c4;
  min-height: 100vh;
  background: #211e1f;
  color: var(--text);
  box-sizing: border-box;
}
.page-top {
  height: 44px;
  background: #211e1f;
  border-bottom: 1px solid #3a3330;
  box-shadow: none;
  box-sizing: border-box;
  .back_left {
    background: url('../images/ban6/left.png') center / 18px 18px no-repeat;
    opacity: 1;
  }
  .big_tit {
    top: 0;
    right: 44px;
    left: 44px;
    width: auto;
    max-width: none;
    height: 44px;
    transform: none;
    color: #f5bc84;
    font-size: 14px;
    font-weight: normal;
    line-height: 44px;
    text-align: center;
  }
}
.movie-content { padding: 0 0 16px; }
.player-card {
  margin: 0;
  padding: 8px 0 4px;
  overflow: hidden;
  background: #000;
}
.movie-descript {
  margin: 0;
  padding: 12px 14px;
  background: #2c2c2c;
  text-align: left;
}
.video-name {
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.play-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  margin-top: 8px;
  color: var(--accent);
  font-size: 12px;
  line-height: 1.5;
}
.watch-benefits {
  padding: 14px 13px;
  background: #211e1f;
}
.watch-benefits-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 56px;
  padding: 9px 20px 9px 26px;
  border-radius: 40px;
  background: linear-gradient(100deg, #f3d1ad, #dfad77);
  color: #925416;
  box-sizing: border-box;
}
.watch-benefits-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  overflow-wrap: anywhere;
  strong {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.25;
  }
  > span { font-size: 10px; line-height: 1.5; }
}
.watch-benefits-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  color: #dfad77;
  font-size: 18px;
}
.movie-body { margin-top: 0; }
.movie-title {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  background: #2c2c2c;
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
}
.section-marker {
  width: 3px;
  height: 14px;
  flex-shrink: 0;
  background: var(--accent);
}
.hotlist {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 12px;
  padding: 18px 10px 0;
}
.hot-card { min-width: 0; cursor: pointer; }
.hot-cover {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  aspect-ratio: 1.45 / 1;
  background: #302d2d;
}
.hot-cover img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hot-meta {
  position: absolute;
  right: 4px;
  bottom: 3px;
  max-width: calc(100% - 8px);
  padding: 2px 6px;
  border-radius: 10px;
  background: rgba(0, 0, 0, .62);
  color: #fff;
  font-size: 10px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hot-name {
  margin-top: 12px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.video-js /deep/ .vjs-progress-control {
  display: none;
  pointer-events: none;
}
.video-js /deep/ .vjs-remaining-time,
.video-js /deep/ .vjs-duration,
.video-js /deep/ .vjs-current-time,
.video-js /deep/ .vjs-time-divider { display: none; }
/deep/ .video-js {
  width: 100%;
  background: #000;
  border-radius: 0;
  overflow: hidden;
}
/deep/ .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -23px;
  margin-left: -45px;
  border: 1px solid rgba(243, 201, 158, .65);
  background: rgba(33, 30, 31, .8);
  color: var(--accent);
}
/deep/ .video-js .vjs-control-bar {
  background: linear-gradient(transparent, rgba(0, 0, 0, .9));
}
/deep/ .video-js .vjs-play-progress,
/deep/ .video-js .vjs-volume-level { background: var(--accent); }
.watch-mask {
  position: fixed;
  inset: 0;
  z-index: 2000;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .65);
  backdrop-filter: blur(3px);
  box-sizing: border-box;
}
.watch-dialog {
  width: 100%;
  max-width: 360px;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid #665344;
  background: #2c2929;
  box-shadow: 0 18px 35px rgba(0, 0, 0, .3);
}
.watch-title {
  position: relative;
  min-height: 48px;
  padding: 12px 48px 12px 18px;
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #f3cfa9, #dfae79);
  color: #794619;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  box-sizing: border-box;
}
.watch-title span { min-width: 0; overflow-wrap: anywhere; }
.watch-close {
  position: absolute;
  top: 8px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, .7);
  color: #a06936;
  font-size: 14px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.watch-content {
  padding: 16px 18px 18px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}
@media screen and (max-width: 374px) {
  .hotlist { gap: 16px 10px; padding-right: 8px; padding-left: 8px; }
}
</style>
